import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseRegressLeadProps {
  id?: string
  onSuccess?: () => void
  onError?: () => void
}

const useRegressLead = ({ id, onSuccess, onError }: UseRegressLeadProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['regressLead'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/establishment/leads/${id}/regress`)
    },
    onSuccess,
    onError,
  })
}

export default useRegressLead